<template>
    <div class="wizard-finished">
        <h1>Gratulerer, din personvernerklæring er nå klar!</h1>
        <img src="https://gdprcontrol.no/assets/img/yay.jpg">
        <p>Vi gjør fra tid til annen endringer i denne malen for personvernerklæring. Kan vi lagre epostadressen din og bruke den til å sende deg informasjon om oppdateringer av denne malen samt informasjon om andre verktøy vi også lager? Du kan selvfølgelig trekke dette samtykket når som helst.<a href="https://gdprcontrol.no/privacy/" target="_blank">Les mer her</a></p>        
        <div class="wizard-yes">            
            <input v-model="email" name="answer" placeholder="Epost" />
            <VueSpinner size="40" v-show="spinJa"/>
            <button class="app-btn" @click="handleClick('ja', email)">Greit, vis meg personvernerklæringen!</button>
        </div>
        <div class="wizard-no">
            <VueSpinner size="20" v-show="spinNei"/>          
            <button class="app-btn" @click="handleClick('nei', email)">Nei takk, bare vis personvernerklæringen</button>
        </div>
    </div>
</template>

<script setup>
    import { notify } from '@kyvg/vue3-notification';
    import { LocalStorageService } from '@/services/LocalStorageService';
    import { ref } from 'vue'
    import { VueSpinner } from 'vue3-spinners';

    const localStorageService = new LocalStorageService();
    const DPO_QUESTION_ID = 11;
    const dpoQuestionState = localStorageService.getQuestionState(DPO_QUESTION_ID);

    const email = ref(dpoQuestionState.userAnswer);

    const spinJa = ref(false);
    const spinNei = ref(false);

    var url = '/personvernerklaeringsgenerator-ferdig';
    history.pushState({"qId" : "ferdig"}, null, url)

    async function postData(url = '', data = {}) {        
        try {
            const response = await fetch(url, {
                method: 'POST',
                mode: 'cors', 
                cache: 'no-cache',    
                headers: {
                  'Content-Type': 'application/json'      
                },    
                referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                body: JSON.stringify(data) // body data type must match "Content-Type" header                
            });
            return response.json(); // parses JSON response into native JavaScript objects
        }
        finally {
            spinJa.value = false;
            spinNei.value = false;
        }
    }

    const handleClick = (consent, email) => {
        if (consent === "ja" && validateEmail(email) === false)
        {
            return notify({ title: 'Epost', text: 'Eposten må være en gyldig epostadresse.', type: 'error' });         
        }

        if (consent === "ja"){            
            spinJa.value = true;
            spinNei.value = false;
        }

        if (consent === "nei"){
            spinJa.value = false;
            spinNei.value = true;
        }
        
        generateDocument(consent, email)
    };

    function validateEmail(email) {
        // eslint-disable-next-line
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    const generateDocument = (consent, email) => {        
        
        generateAndStoreConsent(consent, email);
        trackGoal(consent);

        function trackGoal(consent) {
            if (consent === "ja") {
            window.fathom.trackGoal('6IBGN8MU', 0);
            }
            else {
            window.fathom.trackGoal('UVXO9JI5', 0);
            }
        }   

        function generateAndStoreConsent(consent, email) {
            
            var state = consent === "ja" ? { "contactEmail": email, "questions": localStorageService.getState() } : {"questions": localStorageService.getState() };            
            
            //postData('http://127.0.0.1:3000/personvernerklaeringer', state)
            postData('https://api.gdprcontrol.no/personvernerklaeringer', state)
            .then((data) => {                
                if(data.result==="ok") {
                    window.location.assign(data.link);
                }
            });
        }
    };
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';
.wizard-finished {    
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 5%;

    .wizard-yes {        
        margin-top: 30px;    
        display: flex;
        flex-direction: row;
        align-items: center;
        input {
            margin-right: 20px;                    
            font-size: 18px;
            padding: 10px;
            width: 100%;
            font-family: 'Roboto', sans-serif;
            color: $text-color;
            letter-spacing: 1px;
            border: 2px solid $primary-color;
            border-radius: 5px;
        }
        button{
            border: 2px solid $primary-color;
            padding: 8px 40px;
        }
    }

    .wizard-no {
        margin-top: 30px;
        button{
            border: 1px solid $tetriary-color;
            padding: 8px 40px;
            font-size: 12px;
            font-weight: normal;
        }         
    }
}
</style>
